module.exports = __webpack_public_path__ + "img/banner.8395fcb0.jpg";